// extracted by mini-css-extract-plugin
export default {"app":"app_app__ULBWm","footer":"app_footer__MPN6L","pageContent":"app_pageContent__7q996"};